import { memo, useCallback, useEffect, useState } from 'react';
import componentStyle from './sign-up-banner.style';
import { Box, ButtonV2 } from '@bridebook/ui';
import { Close } from '@bridebook/aura/src/icons';
import { IconBb } from '@bridebook/ui/src/icons';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { Icon } from '@bridebook/aura';

const HIDE_ARTICLE_SIGN_UP_BANNER = 'HIDE_ARTICLE_SIGN_UP_BANNER';

const SignUpBanner = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const [isMounted, setIsMounted] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const styles = componentStyle();

  const handleClose = useCallback(() => {
    setIsHidden(true);
    localStorage.setItem(HIDE_ARTICLE_SIGN_UP_BANNER, 'true');
  }, [setIsHidden]);

  const handleRedirect = useCallback(() => {
    router.push(UrlHelper.signup);
  }, [router]);

  useEffect(() => {
    setIsHidden(!!localStorage.getItem(HIDE_ARTICLE_SIGN_UP_BANNER));
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return (
    <>
      <Box style={styles.boxHolder(isHidden)} />
      <Box style={styles.box(isHidden)}>
        <Box as="button" onClick={handleClose}>
          <Icon icon={Close} />
        </Box>
        <Box style={styles.logoBox}>
          <IconBb color="indigoCrush" width={24} />
        </Box>
        <Box style={styles.text}>{t('signup.details')}</Box>
        <ButtonV2 onClick={handleRedirect} styleWrapper={styles.button} alternative size="small">
          {t('button.signup')}
        </ButtonV2>
      </Box>
    </>
  );
};

export default memo(SignUpBanner);
